import { Injectable } from '@angular/core';
import { BackgroundConfig, IVViewType } from '@root/app.interfaces';
import { IV_VIEW_TYPES, STORAGE_NAMES } from '@root/app.config';
import { SessionStorageService } from '@core/services/session-storage/session-storage.service';

@Injectable({
	providedIn: 'root',
})
export class BackgroundConfigService {
	// TODO: Move background config management logic from Engine service to this service

	constructor(private sessionStorageService: SessionStorageService) {}

	updateIVBackgroundConfig({ theme, settings, shutterValues, sampleProjectBlinds }: Partial<BackgroundConfig>): void {
		const ivViewType = this.sessionStorageService.getSession(STORAGE_NAMES.zip_iv_type) as IVViewType;
		const ivCurrentBackground = this.sessionStorageService.getSession(STORAGE_NAMES.zip_image_visualisation_background);
		const ivUploadedBackground = this.sessionStorageService.getSession(STORAGE_NAMES.zip_uploaded_image_visualisation_background);

		const updatedBackgroundConfig: BackgroundConfig = {
			...(ivViewType === IV_VIEW_TYPES.upload ? ivUploadedBackground : ivCurrentBackground),
			theme,
			settings,
			shutterValues,
			sampleProjectBlinds,
		};

		this.sessionStorageService.setSession(updatedBackgroundConfig, STORAGE_NAMES.zip_image_visualisation_background);

		if (this.getBackgroundConfigViewType(ivCurrentBackground) === IV_VIEW_TYPES.upload) {
			delete updatedBackgroundConfig.theme;
			delete updatedBackgroundConfig.sampleProjectBlinds;
			this.sessionStorageService.setSession(updatedBackgroundConfig, STORAGE_NAMES.zip_uploaded_image_visualisation_background);
		}
	}

	getBackgroundConfigViewType(background: BackgroundConfig): IVViewType {
		if (!background) {
			return null;
		}

		const isProjectSample = background.type && typeof background.index === 'number';

		return isProjectSample ? IV_VIEW_TYPES.project_sample : IV_VIEW_TYPES.upload;
	}
}
